import type { ComponentProps } from 'react';

const Radio = (
  props: ComponentProps<'svg'> & {
    isChecked?: boolean;
  }
) => {
  if (props.isChecked) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect
          x="7.5"
          y="7.5"
          width="9"
          height="9"
          rx="4.5"
          fill="#EE4F5E"
          stroke="#EE4F5E"
        />
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="9"
          stroke="#EE4F5E"
          stroke-width="2"
        />
      </svg>
    );
  }
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="9"
        stroke="#C5CCD6"
        stroke-width="2"
      />
    </svg>
  );
};

export default Radio;
